import { render, staticRenderFns } from "./SalesTabs.vue?vue&type=template&id=7eb69928&scoped=true&lang=pug&"
import script from "./SalesTabs.vue?vue&type=script&lang=js&"
export * from "./SalesTabs.vue?vue&type=script&lang=js&"
import style0 from "./SalesTabs.vue?vue&type=style&index=0&id=7eb69928&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb69928",
  null
  
)

/* custom blocks */
import block0 from "./SalesTabs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports